import { Box, Typography, SxProps, Theme } from "@mui/material";
import React, { ReactNode } from "react";
import { EIconNames } from "../types/iconNames";
import IconComponent from "./IconComponent";

export interface INoteProps {
  message?: ReactNode | string;
  iconName?: EIconNames;
  variant?: ENoteVariant;
  sx?: SxProps<Theme>;
}

export enum ENoteVariant {
  SUCCESS = "success",
  WARNING = "warning",
  ERROR = "error",
  INFO = "info",
}

export const Note: React.FC<INoteProps> = ({
  message,
  iconName,
  variant,
  sx,
}) => {
  const getIconNames = (): EIconNames => {
    switch (variant) {
      case ENoteVariant.SUCCESS: {
        return EIconNames.CHECK_CIRCLE;
      }
      case ENoteVariant.WARNING:
      case ENoteVariant.INFO: {
        return EIconNames.INFO;
      }
      case ENoteVariant.ERROR: {
        return EIconNames.WARNING;
      }
      default: {
        return EIconNames.INFO;
      }
    }
  };

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",

        color: (theme) => {
          switch (variant) {
            case ENoteVariant.SUCCESS: {
              return theme.palette.success.main;
            }
            case ENoteVariant.ERROR: {
              return theme.palette.error.main;
            }
            case ENoteVariant.WARNING: {
              return theme.palette.warning.main;
            }
            case ENoteVariant.INFO: {
              return theme.palette.info.main;
            }
            default: {
              return theme.palette.primary.main;
            }
          }
        },

        ...sx,
      }}
    >
      <IconComponent
        fontSize="1.25rem"
        iconname={iconName ?? getIconNames()}
        style={{ marginRight: 8, flexShrink: 0 }}
      />
      <Typography
        sx={{
          fontWeight: 600,
        }}
      >
        {message}
      </Typography>
    </Box>
  );
};
